import styled from 'styled-components'

export const Container = styled.header`
  position: fixed;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 10px;
  width: 100%;
  height: 60px;

  background-color: ${({ theme }) => theme.colors.background};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};

  z-index: 1000; /* 👈 CLAVE */

  /* DESKTOP con sidebar */
  @media (min-width: 768px) {
    left: 250px;
    width: calc(100% - 250px);
  }
`

export const Box = styled.div`
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
`
